angular.module('impactx.cube').controller('CubeMenuListCtrl', [
    '$controller',
    CubeMenuListCtrl]);

function CubeMenuListCtrl($controller)
{
    angular.extend(this, $controller('SideBarSubMenuCtrl'));
}